import * as React from 'react';
import { useLanguage } from '../../locale';
import { useSearchFilters } from './useSearchFilters';
export var useBudgetFriendlyFilterSectionFacade = function () {
    var t = useLanguage()[0];
    var _a = React.useState(), budgetFriendlyFilterOption = _a[0], setBudgetFriendlyFilterOption = _a[1];
    var _b = useSearchFilters(), setIsBudgetFriendlyToFilter = _b.setIsBudgetFriendlyToFilter, selectedIsBudgetFriendlyFilter = _b.selectedIsBudgetFriendlyFilter;
    var options = React.useMemo(function () {
        return [
            {
                type: 'default',
                label: "".concat(t('yes')),
                value: true,
            },
            {
                type: 'default',
                label: "".concat(t('filters.indifferent')),
                value: false,
            },
        ];
    }, [t]);
    React.useEffect(function () {
        if (selectedIsBudgetFriendlyFilter === null) {
            setBudgetFriendlyFilterOption(null);
        }
        else {
            var optionToSet = options.find(function (o) { return o.value === selectedIsBudgetFriendlyFilter; });
            setBudgetFriendlyFilterOption(optionToSet !== null && optionToSet !== void 0 ? optionToSet : null);
        }
    }, [options, selectedIsBudgetFriendlyFilter]);
    var reset = React.useCallback(function () {
        setBudgetFriendlyFilterOption(null);
        setIsBudgetFriendlyToFilter(null);
    }, [setIsBudgetFriendlyToFilter]);
    var applyFilter = React.useCallback(function () {
        var _a;
        setIsBudgetFriendlyToFilter((_a = budgetFriendlyFilterOption === null || budgetFriendlyFilterOption === void 0 ? void 0 : budgetFriendlyFilterOption.value) !== null && _a !== void 0 ? _a : null);
    }, [budgetFriendlyFilterOption, setIsBudgetFriendlyToFilter]);
    return {
        options: options,
        budgetFriendlyFilterOption: budgetFriendlyFilterOption,
        setBudgetFriendlyFilterOption: setBudgetFriendlyFilterOption,
        reset: reset,
        applyFilter: applyFilter,
    };
};
